<template>
  <v-row>
    <v-col cols="6">
      <v-autocomplete
          v-model="options"
          :items="list"
          :label="unitcode?label:'请选择签约公司'"
          :loading="loading"
          :rules="rules"
          :search-input.sync="search"
          :disabled="disabled || !unitcode"
          :item-text="getMerchantsName"
          item-value="merchantsId"
          return-object
          hide-no-data
          hide-details
          clearable
          outlined
          dense
      ></v-autocomplete>
    </v-col>
    <v-col cols="6">
      <v-select
          v-model="account"
          :items="accountList"
          :item-text="getAccountName"
          :rules="rules"
          :label="merchants && merchants.merchantsId?'银行账户':'请选择客商'"
          :disabled="disabled || !merchants ||!merchants.merchantsId"
          placeholder="请选择客商"
          return-object
          outlined
          dense
      ></v-select>
    </v-col>
  </v-row>

</template>

<script>
import {default as ContractApi} from "@/api/erp/contract/ContractApi";

export default {
  name: "MerchantsAccountSelect",
  data: () => ({
    loading:false,
    list:[],
    search:null,
    accountList:[],
    merchants:{},
  }),
  props: {
    value: {
      type: Object,
    },
    label: {
      type: String,
      default :''
    },
    rules:{
      type: Array
    },
    disabled:{
      type:Boolean,
      default: false
    },
    unitcode:{
      type:String,
      default: ''
    }
  },
  model: {
    prop: 'value',
    event: 'modify',
  },
  watch: {
    search (val) {
      console.log(this.unitcode);
      this.list = []
      val && (!this.value || val !== this.value.merchantsName) && this.listMerchants(val)
    },
  },
  computed: {
    options: {
      get: function () {
        if(this.value && this.value.merchantsId && this.list.length == 0){
          this.list = [{merchantsId:this.value.merchantsId, merchantsName:this.value.merchantsName}];
          this.merchants = this.value;
          this.listMerchantsAccount();
        }
        return this.value //将props中的typeId值赋给value
      },
      set: function (val) {
        this.merchants = val;
        this.listMerchantsAccount();
        this.$emit('modify', this.merchants) //通过$emit触发父组件
      },
    },
    account:{
      get: function (){
        if(this.value && this.value.merchantsAccount) {
          return JSON.parse(this.value.merchantsAccount);
        }
        return {};
      },
      set: function (val){
        this.merchants.merchantsAccount = JSON.stringify(val);
        this.$emit('modify', this.merchants);
      }
    }
  },
  methods: {
    listMerchants(name){
      let me = this;
      this.loading = true;
      if(!this.unitcode){
        return;
      }
      ContractApi.listMerchants({name:name, unitcode:this.unitcode}).then(data=> {
              me.loading = false;
              me.list = data;
      }).catch(error=>{
              me.loading = false;
          })
    },
    listMerchantsAccount(){
      if(!this.merchants || !this.merchants.merchantsId){
        this.accountList = [];
        return;
      }
      let me = this;
      ContractApi.listMerchantsAccount({merchantsId:this.merchants.merchantsId, unitcode:this.unitcode}).then(data=>{
        me.accountList = data;
      })
    },
    getAccountName(account){
      return `${account.bankName} ${account.account}`;
    },
    getMerchantsName(merchants){
      return `${merchants.merchantsName} (${merchants.merchantsId})`;
    },
  }
}
</script>

<style scoped>

</style>